export default __webpack_public_path__ + "7d986645c75af86872907fe4ee3c8aad.png";